import { render } from "./xjadd.vue?vue&type=template&id=40c9623c&scoped=true"
import script from "./xjadd.vue?vue&type=script&lang=js"
export * from "./xjadd.vue?vue&type=script&lang=js"

import "./xjadd.vue?vue&type=style&index=0&id=40c9623c&lang=scss&scoped=true"
import "./xjadd.vue?vue&type=style&index=1&id=40c9623c&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c9623c"]])

export default __exports__